export default {
    API_ENDPOINT_FOLDERS: `https://calm-wave-20374.herokuapp.com/api/folders/`,
    API_ENDPOINT_NOTES: `https://calm-wave-20374.herokuapp.com/api/notes/`,
    API_KEY:`7772158-1931-432a-968e-9c81ea5d5e19`,
}